import { IconClock } from "@tine/designsystem-icons/sharp";
import isNil from "lodash-es/isNil";
import { observer } from "mobx-react-lite";
import { type ReactNode, useRef, useState } from "react";

import { translateDayLabel } from "../../common/utils";
import { formatDate, formatDateTime } from "../../common/utils/dateUtils";
import Button from "../../components/Button";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/common/popover/Popover";
import DeliveryDateButton from "../../components/deliverydates/DeliveryDateButton";
import InfoLine from "../../components/InfoLine";
import cartStore from "../../stores/cart/cartStore";
import deliveryDatesStore from "../../stores/deliveryDates/deliveryDatesStore";
import theme from "../../themes/theme";

const MobileDeliveryInfo = () => {
   const ref = useRef<HTMLButtonElement>(null);
   const [show, setShow] = useState<boolean>(false);
   const currentDelivery = deliveryDatesStore.getCurrentDelivery();

   if (isNil(currentDelivery)) {
      return null;
   }

   const dayLabel = translateDayLabel(cartStore.orderType, theme.deliveryMethod);

   const renderDeliveryDateButton: (dates: Date[], isPickerOpen: boolean, setPickerOpen: (show: boolean) => void) => ReactNode = (
      _dates,
      isPickerOpen,
      setPickerOpen
   ) => {
      return (
         <Button className="m-2" variant="secondary" size="regular" onClick={() => setPickerOpen(!isPickerOpen)}>
            Endre leveringsdag
         </Button>
      );
   };

   return (
      <Popover open={show} onOpenChange={setShow}>
         <PopoverTrigger asChild>
            <Button
               icon={<IconClock />}
               ref={ref}
               variant="tertiary"
               size="iconOnly"
               onClick={() => setShow(!show)}
               trackingName="Leveringsinfo"
            />
         </PopoverTrigger>
         <PopoverContent>
            <div className="px-3 pt-3 w-[300px]">
               <InfoLine margin label="Bestillingsfrist" value={formatDateTime(currentDelivery.deadline, true, true)} />
               <InfoLine margin label={dayLabel} value={formatDate(currentDelivery.date, true, false, true)} />
            </div>
            {!cartStore.editing?.isGeneratedSubscriptionOrder && <DeliveryDateButton render={renderDeliveryDateButton} inline />}
         </PopoverContent>
      </Popover>
   );
};

export default observer(MobileDeliveryInfo);
